import React, { useCallback } from "react";
import PropTypes from "prop-types";

import Headline from "../../Atoms/Headline";
import LinkSwitcher from "../../Atoms/Link/LinkSwitcher";
import SimpleAccordionItem from "./SimpleAccordionItem";

const SimpleAccordion = ({
  properties: {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    id,
    accordionItems,
    animation,
  },
}) => {
  const renderAccordion = useCallback(() => {
    return accordionItems.map((accordionItem) => {
      return (
        <SimpleAccordionItem
          key={`key_${accordionItem.id || Math.random()}`}
          id={`accordion-${id}`}
          accordionItem={accordionItem}
          animation={animation}
        />
      );
    });
  }, [accordionItems, id, animation]);

  return (
    <div className="container accordion simple">
      <div className="row justify-content-center">
        <div className="col-md-10">
          <Headline headerType={headerType} headerStyle={headerDisplayStyle} headline={header} />
        </div>
      </div>

      {accordionItems.length > 0 && (
        <div className="row justify-content-center mt-small">
          <div className="col-md-10">
            <div className="accordion-flush" id={`accordion-${id}`}>
              {renderAccordion()}
            </div>
          </div>
        </div>
      )}

      {headerLink && (
        <div className="row justify-content-center mt-small" data-aos={animation.links.default}>
          <div className="col-md-10">
            <div className="links">
              <LinkSwitcher linkType={headerLinkType} link={headerLink} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

SimpleAccordion.propTypes = {
  properties: PropTypes.instanceOf(Object),
};

export default SimpleAccordion;
